import React, { Component } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { get as _get } from "lodash";

import { withRouter } from "../../resusableComponents/hoc/withRouter";
import { applicationRoutes } from "./../../helpers/constants";

import UnderConstruction from "../CommonPages/UnderConstruction";
import SavedDataSearch from "../SavedDataSearch";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import DataSearch from "../DataSearch";
import Settings from "../Settings";
import History from "../History";
import AddData from "../AddData";
import Enrich from "../Enrich";

const resusableComponents = {
  underConstruction: UnderConstruction,
  savedDataSearch: SavedDataSearch,
  dataSearch: DataSearch,
  settings: Settings,
  addData: AddData,
  history: History,
  enrich: Enrich,
}

class Application extends Component {

  render() {
    const { isNavbarVisible } = this.props;

    return (
      <React.Fragment>
        <div className="layout-wrapper layout-content-navbar">
          <div className="layout-container">
            <Sidebar />
            <div className={`layout-page ${(isNavbarVisible === true) ? "" : "active"}`}>
              <Header />
              <div className="content-wrapper">
                <Routes>
                  {
                    applicationRoutes.map(({ component, ...rest }, key) => {

                      const RouteComponent = (resusableComponents[component] || "");

                      if (typeof RouteComponent !== "undefined" && RouteComponent !== "") {
                        return <Route key={key} {...rest} element={<RouteComponent />} />
                      } else {
                        return null;
                      }
                    })
                  }
                  <Route path="*" element={<Navigate from="*" to="/" replace />} />
                </Routes>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, props) => ({
  isNavbarVisible: _get(state, "application.isNavbarVisible", false)
});

export default withRouter(connect(mapStateToProps, null)(injectIntl(Application)));
